import React, { FC, useEffect } from 'react'
import ReactModal from 'react-modal'
import { VideoSelectActionType } from '../types/LocalVideoAction';
import { VideoType } from '../types/models/Media/Video';
import Video from './Video';
import { fixBackground, releaseBackground } from "../utils/utilFunctions"
import { CloseIcon } from '../icons/CloseIcon';
import { useDispatch } from 'react-redux';

ReactModal.setAppElement( "#___gatsby" );

const modalStyle: ReactModal.Styles = {
    overlay: {
        position: "fixed",
        bottom: 0,
        right: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0,0,0,0.7)",
        zIndex: 9,
        textAlign: "center"
    },
    content: {
        position: "absolute",
        display: "flex",
        justifyContent: 'center',
        alignItems: 'center',
        top:0,
        bottom:0,
        left:0,
        right:0,
        width: "100vw",
        height: "100vh",
        padding: 0,
        backgroundColor: "rgba(0,0,0,0)",
        border: "none",
    },
    
};

type Props = {
    modalVisible: boolean
    setModalVisible: ( visible: boolean ) => void
    file: string,
    thumbnail: string,
    handleVideoSelectSwitch: ( action: VideoSelectActionType, video: VideoType ) => void,
    videoIsSelected: boolean
}

export const VideoModal: FC<Props> = ( {
    file, thumbnail, handleVideoSelectSwitch,
    videoIsSelected,
    modalVisible, setModalVisible } ) => {

    const dispatch = useDispatch()

    // useEffect( () => {
    //     modalVisible ?
    //         fixBackground() :
    //         releaseBackground()
    // }, [ modalVisible ] )

    return (
        <ReactModal
            isOpen={ modalVisible }
            onRequestClose={ () => setModalVisible( false ) }
            shouldCloseOnOverlayClick={ false }
            shouldCloseOnEsc
            style={ modalStyle }
            contentLabel="Video">
            <div
                style={ { width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" } }
                onClick={ () => dispatch( { type: "setCommentFormVisible", commentFormVisible: false } ) }>
                <div style={ { position: "relative", width: "100%", maxWidth: 800 } }>
                    <CloseIcon style={ {
                        position: "absolute",
                        top: -32,
                        right: 0,
                        fontSize: 28,
                        color: "#fff",
                        zIndex:3
                    } } onClick={ () => setModalVisible( false ) } />
                    <Video
                        sync={ false }
                        index={ 0 }
                        action={ null }
                        dispatch={ () => { } }
                        forComparison={ false }
                        originalFile={ file }
                        thumbnail={ thumbnail }
                        handleVideoSelectSwitch={ handleVideoSelectSwitch }
                        showThumbnailInitially={ false }
                        videoLoadAndAutoPlay={ true }
                        showVideo={ () => { } }
                        videoIsSelected={ videoIsSelected }
                    />
                </div>
            </div>
        </ReactModal>
    )
}
